import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { DownloadStatusPageRoutingModule } from './download-status-routing.module';

import { DownloadStatusPage } from './download-status.page';
import { ComponentsModule } from 'src/app/components/components.module';
import { PipesModule } from 'src/app/pipes/pipes.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ComponentsModule,
    PipesModule,
    DownloadStatusPageRoutingModule
  ],
  declarations: [DownloadStatusPage]
})
export class DownloadStatusPageModule {}
